import { ApiManager } from 'utlis/api_manager';
import http from 'utlis/http';

const api = new ApiManager(process.env.REACT_APP_BASE_URL, 1);
const designAuditApi = process.env.REACT_APP_DESIGN_AUDIT_BASE_URL;

export async function generatePersona(audienceText, productName = null, signal = null) {
  const body = { audience_text: audienceText };

  if (productName) {
    body.product_name = productName;
  }

  const { data } = await http.post(
    `${designAuditApi}/generate_persona`,
    body,
    {
      headers: {
        'Content-Type': 'application/json',
        'X-BACKEND-URL': process.env.REACT_APP_X_BACKEND_URL,
      },
      ...(signal ? { signal } : {}),
    }
  );

  return data;
}

export async function createPersona(workspaceUuid, { name, standardSummary, expandedRecord, sourceInput }) {
  const url = `project/team/workspaces/${workspaceUuid}/personas`;

  const { data } = await api.setUrl(url).post({
    name,
    standard_summary: standardSummary,
    expanded_record: expandedRecord,
    source_input: sourceInput || '',
  });

  return data;
}

export async function listPersonas(workspaceUuid) {
  const url = `project/team/workspaces/${workspaceUuid}/personas`;

  const { data } = await api.setUrl(url).get();

  return data;
}
